import { render, staticRenderFns } from "./ActivixMultiselect.vue?vue&type=template&id=0e6d90f6&"
import script from "./ActivixMultiselect.vue?vue&type=script&lang=js&"
export * from "./ActivixMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports